import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { IGroupWithIds } from "@app/main/components/resourceManagement/groups/_models/IGroupWithIds";
import { GroupService } from "@app/services/groups/group.service";
import { VButtonStatus } from "@directives/_forms/v-input/v-input.component";
import "./group-autocomplete.component.scss";

@Component({
    selector: "group-autocomplete",
    template: require("./group-autocomplete.component.html")
})
export class GroupAutocompleteComponent implements OnChanges, OnInit {
    @Input() selectedGroup: IGroupWithIds;
    @Input() selectedGroupId: number;
    @Input() groups: IGroupWithIds[];
    @Input() label: string;
    @Input() placeholder: string;
    @Input() customDropdownHeight: number;

    @Output() groupSelected: EventEmitter<IGroupWithIds> = new EventEmitter();
    @Output() clear = new EventEmitter<void>();
    @ViewChild("groupSearchInput", { read: ElementRef }) groupSearchInputRef: ElementRef<HTMLElement>;

    text: string = '';
    showDropdown = false;
    inputStatus = VButtonStatus.Default;
    loading = false;

    constructor(private groupService: GroupService) { }

    ngOnChanges(changes: SimpleChanges) {
        if (this.selectedGroupId !== null && this.selectedGroupId !== undefined) {
            this.loadGroups();
        } else {
            this.onClear();
        }
    }

    ngOnInit(): void {
        if (this.selectedGroupId) {
            this.text = this.selectedGroup?.Name || '';
        }
    }

    public resetSelection(): void {
        this.selectedGroup = null;
        this.selectedGroupId = null;
        this.text = '';
        this.inputStatus = VButtonStatus.Default;
        this.clear.emit();
        this.groupSelected.emit(null);
        this.loadGroups();
    }

    onFocus() {
        this.showDropdown = true;
        this.loadGroups();
    }

    onGroupSelected(group: IGroupWithIds) {
        if (!group) {
            return;
        }
        
        this.selectedGroup = group;
        this.selectedGroupId = group.Id;
        this.text = group.Name;
        this.inputStatus = VButtonStatus.Success;
        this.showDropdown = false;
        this.groupSelected.emit(group);
    }

    onTextChanged(text: string) {
        if (text === this.text) {
             return;
        }

        this.selectedGroup = null;
        this.inputStatus = VButtonStatus.Default;
        this.text = text;
        this.clear.emit();
    }

    onDropdownClosed() {
        this.showDropdown = false;
    }

    onClear(): void {
        this.resetSelection();
    }

    private loadGroups() {
        this.loading = true;
        this.groupService.getGroupsWithIds()
            .then(groups => {
                this.groups = groups;
                this.selectGroup();
            })
            .catch(err => {
                console.error('Error loading groups', err);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private selectGroup(): void {
        if (!this.selectedGroupId) {
            return;
        }

        const matchingGroup = this.groups.find(g => g.Id === this.selectedGroupId);

        if (matchingGroup) {
            this.onGroupSelected(matchingGroup);
        } else {
            this.groupSelected.emit(null);
        }
    }
}